var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.951,
    height: 50.189,
    viewBox: "0 0 34.951 50.189",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#1c6f97;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-17)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(17)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.093,18.792h4.173a.448.448,0,0,0,.435-.34l.224-.9A.448.448,0,0,0,25.491,17H20.869a.448.448,0,0,0-.435.557l.224.9A.448.448,0,0,0,21.093,18.792Z",
    transform: "translate(-17.355 -1.765)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M26.916,51.874c-.269-2.372-.8-7.479-1.344-14.736v-.007c-.334-4.464-.671-9.742-.952-15.7A.448.448,0,0,0,24.172,21h-2.24a.448.448,0,0,0-.448.431c-.738,15.641-1.867,26.61-2.3,30.443a.448.448,0,0,0,.448.492H26.47a.448.448,0,0,0,.446-.5Z",
    transform: "translate(-17.227 -2.181)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 7,
    height: 2,
    rx: 0.5,
    transform: "translate(26 28.185)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 5,
    height: 2,
    rx: 0.5,
    transform: "translate(26 25.185)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24.24,5.377a.448.448,0,0,0,.448-.448V1.344a1.344,1.344,0,1,0-2.689,0V4.929a.448.448,0,0,0,.448.448Z",
    transform: "translate(-17.519)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20.659,8.34l-.224.9a.448.448,0,0,0,.435.557h4.622a.448.448,0,0,0,.435-.557l-.224-.9A.448.448,0,0,0,25.268,8H21.094A.448.448,0,0,0,20.659,8.34Z",
    transform: "translate(-17.355 -0.831)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.344,12a1.344,1.344,0,1,0,0,2.689h8.962a1.344,1.344,0,0,0,0-2.689Z",
    transform: "translate(-17 -1.246)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M40.689,48.774h-2.24a.448.448,0,0,0-.448.448V51.91a.448.448,0,0,0,.448.448h4.481a.448.448,0,0,0,.448-.448V23.616a.448.448,0,0,0-.247-.4l-4.481-2.24a.448.448,0,0,0-.649.4v3.65a.448.448,0,0,0,.448.448h2.24a.9.9,0,1,1,0,1.792h-2.24a.448.448,0,0,0-.448.448v.9a.448.448,0,0,0,.448.448h2.24a.9.9,0,1,1,0,1.792h-2.24A.448.448,0,0,0,38,31.3v.9a.448.448,0,0,0,.448.448h2.24a.9.9,0,1,1,0,1.792h-2.24a.448.448,0,0,0-.448.448v.9a.448.448,0,0,0,.448.448h2.24a.9.9,0,0,1,0,1.792h-2.24a.448.448,0,0,0-.448.448v.9a.448.448,0,0,0,.448.448h2.24a.9.9,0,1,1,0,1.792h-2.24a.448.448,0,0,0-.448.448v.9a.448.448,0,0,0,.448.448h2.24a.9.9,0,0,1,0,1.792h-2.24a.448.448,0,0,0-.448.448v.9a.448.448,0,0,0,.448.448h2.24a.9.9,0,1,1,0,1.792Z",
    transform: "translate(-19.18 -2.173)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M54.514,36H46.448a.448.448,0,0,0-.448.448V53.475a.448.448,0,0,0,.448.448h8.066a.448.448,0,0,0,.448-.448V36.448A.448.448,0,0,0,54.514,36Zm-2.24,15.235H48.688a.9.9,0,0,1,0-1.792h3.585a.9.9,0,1,1,0,1.792Zm0-3.585H48.688a.9.9,0,0,1,0-1.792h3.585a.9.9,0,1,1,0,1.792Zm0-3.585H48.688a.9.9,0,0,1,0-1.792h3.585a.9.9,0,1,1,0,1.792Zm0-3.585H48.688a.9.9,0,0,1,0-1.792h3.585a.9.9,0,1,1,0,1.792Z",
    transform: "translate(-20.011 -3.738)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M32.526,43.585h2.24a.448.448,0,0,0,.448-.448V40.448A.448.448,0,0,0,34.766,40H28.88a.453.453,0,0,0-.448.489c.525,6.75,1.024,11.41,1.255,13.456a.448.448,0,0,0,.448.393h4.631a.448.448,0,0,0,.448-.448v-.9a.448.448,0,0,0-.448-.448h-2.24a.9.9,0,0,1,0-1.792h2.24a.448.448,0,0,0,.448-.448v-.9a.448.448,0,0,0-.448-.448h-2.24a.9.9,0,1,1,0-1.792h2.24a.448.448,0,0,0,.448-.448v-.9a.448.448,0,0,0-.448-.448h-2.24a.9.9,0,0,1,0-1.792Z",
    transform: "translate(-18.187 -4.153)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M31.143,35h-2.63a.448.448,0,0,0-.448.484q.063.917.127,1.792a.448.448,0,0,0,.448.411h2.5a.448.448,0,0,0,.448-.448V35.447A.448.448,0,0,0,31.143,35Z",
    transform: "translate(-18.149 -3.634)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCities);
export default __webpack_public_path__ + "static/media/icon_cities.be2d65777a0d185d55b888c1d2248659.svg";
export { ForwardRef as ReactComponent };